import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { defer, finalize } from 'rxjs';
import { LoaderService } from '../../core/services/loader.service';

const isBackgroundAuthRequest = (url: string): boolean =>
  url.includes('/token') || url.includes('/refreshtoken');

export const loadingInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const loaderService = inject(LoaderService);

  if (req.headers.has('X-Skip-Loader') || isBackgroundAuthRequest(req.url)) {
    return next(req);
  }

  return defer(() => {
    loaderService.show();
    return next(req);
  }).pipe(
    finalize(() => loaderService.hide())
  );
};
